import { combineReducers } from "redux";
import { reducer as documentCategoriesReducer } from "./documentCategoriesSlice";
import { reducer as documentsReducer } from "./documentsSlice";

export const reducer = combineReducers({
  documents: documentsReducer,
  documentCategories: documentCategoriesReducer,
});
